import { render } from "./CoachItem.vue?vue&type=template&id=6e5ce3ed&scoped=true"
import script from "./CoachItem.vue?vue&type=script&lang=js"
export * from "./CoachItem.vue?vue&type=script&lang=js"

import "./CoachItem.vue?vue&type=style&index=0&id=6e5ce3ed&scoped=true&lang=css"

import exportComponent from "/Users/michaelp/Library/CloudStorage/OneDrive-個人/Visual Studio/Vue Complete/auth-09-adding-auto-login/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5ce3ed"]])

export default __exports__